import { Component, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Member } from '../../class/ana-chatroom';
import { BaseConfigProvider } from '../../providers/base-config/base-config';

/**
 * Generated class for the ContactItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'contact-item',
  templateUrl: 'contact-item.html',
})
export class ContactItemComponent implements OnChanges {
  @Input() index: number;
  @Input() order: number;
  @Input() member: Member;
  @Input() is_desc: boolean;
  @Input() scope: number;
  @Input() owner_id: number;

  sorts = [
    // { name: '影响力', value: 'effect_count', func: 'effect_' },
    { name: '发言数', value: 'speak_count', func: 'speak_' },
    { name: '拉新数', value: 'invitation_count', func: 'invitation_' },
    { name: '被@数', value: 'be_at_count', func: 'be_at_' },
  ];

  constructor() {}

  // tip_num;
  ngOnChanges(change: SimpleChanges) {
    // this.order = this.order);
    // this.tip_num = Math.round(this.member[this.sorts[this.order - 1].value] - this.input_value);
    console.log(this.order);
  }
}



// WEBPACK FOOTER //
// ./src/components/contact-item/contact-item.ts